export var COOKIE_KEY_PREFIX = 'actionToolbar_initialState_';